// Generated by purs version 0.13.8
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Control_Semigroupoid = require("../Control.Semigroupoid/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Functor_Variant = require("../Data.Functor.Variant/index.js");
var Data_FunctorWithIndex = require("../Data.FunctorWithIndex/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Variant = require("../Data.Variant/index.js");
var Record_Builder = require("../Record.Builder/index.js");
var Type_Data_RowList = require("../Type.Data.RowList/index.js");
var ConstMapping = function (x) {
    return x;
};
var MappingWithIndex = function (mappingWithIndex) {
    this.mappingWithIndex = mappingWithIndex;
};
var Mapping = function (mapping) {
    this.mapping = mapping;
};
var MapVariantWithIndex = function (mapVariantWithIndex) {
    this.mapVariantWithIndex = mapVariantWithIndex;
};
var MapVariantFWithIndex = function (mapVariantFWithIndex) {
    this.mapVariantFWithIndex = mapVariantFWithIndex;
};
var MapRecordWithIndex = function (mapRecordWithIndexBuilder) {
    this.mapRecordWithIndexBuilder = mapRecordWithIndexBuilder;
};
var HMapWithIndex = function (hmapWithIndex) {
    this.hmapWithIndex = hmapWithIndex;
};
var HMap = function (hmap) {
    this.hmap = hmap;
};
var mappingWithIndex = function (dict) {
    return dict.mappingWithIndex;
};
var mappingFunction = new Mapping(function (k) {
    return k;
});
var mapping = function (dict) {
    return dict.mapping;
};
var mapVariantWithIndexNil = new MapVariantWithIndex(function (v) {
    return function (v1) {
        return Data_Variant.case_;
    };
});
var mapVariantWithIndex = function (dict) {
    return dict.mapVariantWithIndex;
};
var mapVariantWithIndexCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictMappingWithIndex) {
                return function (dictMapVariantWithIndex) {
                    return new MapVariantWithIndex(function (v) {
                        return function (fn) {
                            return Data_Variant.on()(dictIsSymbol)(Data_Symbol.SProxy.value)((function () {
                                var $65 = Data_Variant.inj()(dictIsSymbol)(Data_Symbol.SProxy.value);
                                var $66 = mappingWithIndex(dictMappingWithIndex)(fn)(Data_Symbol.SProxy.value);
                                return function ($67) {
                                    return $65($66($67));
                                };
                            })())(mapVariantWithIndex(dictMapVariantWithIndex)(Type_Data_RowList.RLProxy.value)(fn));
                        };
                    });
                };
            };
        };
    };
};
var mapVariantFWithIndexNil = new MapVariantFWithIndex(function (v) {
    return function (v1) {
        return Data_Functor_Variant.case_;
    };
});
var mapVariantFWithIndex = function (dict) {
    return dict.mapVariantFWithIndex;
};
var mapVariantFWithIndexCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictMappingWithIndex) {
                return function (dictMapVariantFWithIndex) {
                    return function (dictFunctor) {
                        return new MapVariantFWithIndex(function (v) {
                            return function (fn) {
                                return Data_Functor_Variant.on()(dictIsSymbol)(Data_Symbol.SProxy.value)((function () {
                                    var $68 = Data_Functor_Variant.inj()(dictIsSymbol)(dictFunctor)(Data_Symbol.SProxy.value);
                                    var $69 = mappingWithIndex(dictMappingWithIndex)(fn)(Data_Symbol.SProxy.value);
                                    return function ($70) {
                                        return $68($69($70));
                                    };
                                })())(mapVariantFWithIndex(dictMapVariantFWithIndex)(Type_Data_RowList.RLProxy.value)(fn));
                            };
                        });
                    };
                };
            };
        };
    };
};
var mapRecordWithIndexNil = new MapRecordWithIndex(function (v) {
    return function (v1) {
        return Control_Category.identity(Record_Builder.categoryBuilder);
    };
});
var mapRecordWithIndexBuilder = function (dict) {
    return dict.mapRecordWithIndexBuilder;
};
var mapRecordWithIndexCons = function (dictIsSymbol) {
    return function (dictMappingWithIndex) {
        return function (dictMapRecordWithIndex) {
            return function (dictCons) {
                return function (dictCons1) {
                    return new MapRecordWithIndex(function (v) {
                        return function (f) {
                            return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(Record_Builder.modify()()(dictIsSymbol)(Data_Symbol.SProxy.value)(mappingWithIndex(dictMappingWithIndex)(f)(Data_Symbol.SProxy.value)))(mapRecordWithIndexBuilder(dictMapRecordWithIndex)(Type_Data_RowList.RLProxy.value)(f));
                        };
                    });
                };
            };
        };
    };
};
var hmapWithIndexVariantF = function (dictRowToList) {
    return function (dictMapVariantFWithIndex) {
        return new HMapWithIndex(mapVariantFWithIndex(dictMapVariantFWithIndex)(Type_Data_RowList.RLProxy.value));
    };
};
var hmapWithIndexVariant = function (dictRowToList) {
    return function (dictMapVariantWithIndex) {
        return new HMapWithIndex(mapVariantWithIndex(dictMapVariantWithIndex)(Type_Data_RowList.RLProxy.value));
    };
};
var hmapWithIndexRecord = function (dictRowToList) {
    return function (dictMapRecordWithIndex) {
        return new HMapWithIndex((function () {
            var $71 = mapRecordWithIndexBuilder(dictMapRecordWithIndex)(Type_Data_RowList.RLProxy.value);
            return function ($72) {
                return Record_Builder.build($71($72));
            };
        })());
    };
};
var hmapWithIndexApp = function (dictFunctorWithIndex) {
    return function (dictMappingWithIndex) {
        return new HMapWithIndex(function (f) {
            return function (v) {
                return Data_FunctorWithIndex.mapWithIndex(dictFunctorWithIndex)(mappingWithIndex(dictMappingWithIndex)(f))(v);
            };
        });
    };
};
var hmapWithIndex = function (dict) {
    return dict.hmapWithIndex;
};
var hmapVariantF = function (dictRowToList) {
    return function (dictMapVariantFWithIndex) {
        return new HMap((function () {
            var $73 = mapVariantFWithIndex(dictMapVariantFWithIndex)(Type_Data_RowList.RLProxy.value);
            return function ($74) {
                return $73(ConstMapping($74));
            };
        })());
    };
};
var hmapVariant = function (dictRowToList) {
    return function (dictMapVariantWithIndex) {
        return new HMap((function () {
            var $75 = mapVariantWithIndex(dictMapVariantWithIndex)(Type_Data_RowList.RLProxy.value);
            return function ($76) {
                return $75(ConstMapping($76));
            };
        })());
    };
};
var hmapTuple = function (dictMapping) {
    return function (dictMapping1) {
        return new HMap(function (fn) {
            return function (v) {
                return new Data_Tuple.Tuple(mapping(dictMapping)(fn)(v.value0), mapping(dictMapping1)(fn)(v.value1));
            };
        });
    };
};
var hmapRecord = function (dictRowToList) {
    return function (dictMapRecordWithIndex) {
        return new HMap((function () {
            var $77 = mapRecordWithIndexBuilder(dictMapRecordWithIndex)(Type_Data_RowList.RLProxy.value);
            return function ($78) {
                return Record_Builder.build($77(ConstMapping($78)));
            };
        })());
    };
};
var hmapEither = function (dictMapping) {
    return function (dictMapping1) {
        return new HMap(function (fn) {
            return function (v) {
                if (v instanceof Data_Either.Left) {
                    return new Data_Either.Left(mapping(dictMapping)(fn)(v.value0));
                };
                if (v instanceof Data_Either.Right) {
                    return new Data_Either.Right(mapping(dictMapping1)(fn)(v.value0));
                };
                throw new Error("Failed pattern match at Heterogeneous.Mapping (line 119, column 13 - line 121, column 36): " + [ v.constructor.name ]);
            };
        });
    };
};
var hmapApp = function (dictFunctor) {
    return function (dictMapping) {
        return new HMap(function (f) {
            return function (v) {
                return Data_Functor.map(dictFunctor)(mapping(dictMapping)(f))(v);
            };
        });
    };
};
var hmap = function (dict) {
    return dict.hmap;
};
var constMapping = function (dictMapping) {
    return new MappingWithIndex(function (v) {
        return function (v1) {
            return mapping(dictMapping)(v);
        };
    });
};
module.exports = {
    hmap: hmap,
    hmapWithIndex: hmapWithIndex,
    mapRecordWithIndexBuilder: mapRecordWithIndexBuilder,
    mapVariantFWithIndex: mapVariantFWithIndex,
    mapVariantWithIndex: mapVariantWithIndex,
    mapping: mapping,
    mappingWithIndex: mappingWithIndex,
    Mapping: Mapping,
    MappingWithIndex: MappingWithIndex,
    ConstMapping: ConstMapping,
    HMap: HMap,
    HMapWithIndex: HMapWithIndex,
    MapRecordWithIndex: MapRecordWithIndex,
    MapVariantWithIndex: MapVariantWithIndex,
    MapVariantFWithIndex: MapVariantFWithIndex,
    mappingFunction: mappingFunction,
    constMapping: constMapping,
    hmapApp: hmapApp,
    hmapWithIndexApp: hmapWithIndexApp,
    hmapRecord: hmapRecord,
    hmapWithIndexRecord: hmapWithIndexRecord,
    mapRecordWithIndexCons: mapRecordWithIndexCons,
    mapRecordWithIndexNil: mapRecordWithIndexNil,
    hmapTuple: hmapTuple,
    hmapEither: hmapEither,
    hmapVariant: hmapVariant,
    hmapWithIndexVariant: hmapWithIndexVariant,
    mapVariantWithIndexCons: mapVariantWithIndexCons,
    mapVariantWithIndexNil: mapVariantWithIndexNil,
    hmapVariantF: hmapVariantF,
    hmapWithIndexVariantF: hmapWithIndexVariantF,
    mapVariantFWithIndexCons: mapVariantFWithIndexCons,
    mapVariantFWithIndexNil: mapVariantFWithIndexNil
};
